import React from "react";
import Col from "react-bootstrap/Col";
import { PortfolioItem } from "./PortfolioItem";

function PortfoliosTab({ portfolios, labels }) {
  return (
    <>
      <Col className="portfolios" xs={12} md={12}>

        {portfolios.map((item, index) => (
            <PortfolioItem key={`portfolio-item-${index}`} item={item} labels={labels} />
        ))}
      
      </Col>
  
    </>
  );
}

export default PortfoliosTab;
